import React, { PureComponent, Fragment } from 'react';
import { Card, CardBody, Col, Progress, Badge, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';

import UnitsSearchTableHead from './UnitsSearchTableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip } from '@material-ui/core';
import moment from "moment";
import FloorPlanIcon from 'mdi-react/FloorPlanIcon';

import LinearLoading from '../../../shared/components/LinearLoading';
import Button from '@material-ui/core/Button';
import LoadMoreIcon from 'mdi-react/RefreshIcon';
import LoadingIcon from 'mdi-react/DotsHorizontalIcon';

import CharityIcon from 'mdi-react/CharityIcon';

import OpenInNewIcon from 'mdi-react/OpenInNewIcon';

import AlertIcon from 'mdi-react/InformationOutlineIcon';
import UnitIcons from '../../../shared/components/UnitIcons';
import AddCollectionButton from '../../../shared/components/collections/AddCollectionButton';
import ArrowUpIcon from 'mdi-react/ChevronUpCircleOutlineIcon';
import ArrowDownIcon from 'mdi-react/ChevronDownCircleOutlineIcon';
import IconButton from '@material-ui/core/IconButton';
import ArrowEqualIcon from 'mdi-react/MinusCircleOutlineIcon';

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";

import { 
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
	buildingFL,
	_replaceAbbreviations,
	_objectEqual,
	StatusBadge,
	_getUnitFloorPlan,
	UnitCurrentStatus,
	_formatUnitNumber,
	HouseCurrentStatus
} from "../../../shared/helpers/utils";

import { _axiosCall } from '../../../shared/helpers/apicalls';
const buildingUrl = process.env.API_ROOT + '/query/';
const profileColors = ['#9decd6', '#9eb3c1', '#f9b2b2', '#66abf5'];
class UnitsListTable extends PureComponent{
	state = {
	    order: "",
	    orderBy: "",
	    selected: new Map([]),
	    page: 0,
	    rowsPerPage: 20,
	    fetchInProgress: false,
		buildingKey:false,
		unitListData:[],
		start:0,
		noMoreResults:false,
		selectedUnits: {}
	};

	componentDidMount() {
		
		if(this.props.buildingKey){
			this.queryUnits();
		}
	  	
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		
		if(this.props.buildingKey){
		  if(!_objectEqual(this.props.q, prevProps.q) ||
		  (this.props.buildingKey !== prevProps.buildingKey ||
		   this.state.orderBy !== prevState.orderBy ||
		   this.state.order !== prevState.order ||
		   this.state.start !== prevState.start)){
			   
			 const reset = this.state.orderBy !== prevState.orderBy || this.state.order !== prevState.order;
			 this.queryUnits(reset);
		  }		 
		}
		 
    }
    
    _loadMore = () => {
	  if(this.state.fetchInProgress === true){
		  	return false;
	  }
	  this.setState({ start: (this.state.start+this.state.rowsPerPage) });    
	  
    }
    
    _handleRequestUnitsSort = (event, property) => {
	    const orderBy = property;
	    let order = 'desc';
	    
	console.log(event, property);    
	    const { orderBy: stateOrderBy, order: stateOrder } = this.state;
	
	    if (stateOrderBy === property && stateOrder === 'desc') { order = 'asc'; }
	
	    this.setState({ order, orderBy, start: 0 });
	};
	

	
	queryUnits = async(reset) => {
		
		if (!this.state.fetchInProgress) {
			this.setState(prevState => ({ fetchInProgress: true, }));
		}
		
		const {buildingKey, q, fq, fl } = this.props;	
		const { orderBy, order } = this.state;
		
		const isContract = this.props.subFilters.offering_status && this.props.subFilters.offering_status === 'in-contract';
		
		let sort = "floor asc, address_2_normalized asc"
		if(this.state.orderBy && this.state.orderBy.length > 0){
			
			if(orderBy === 'address_2_normalized'){
				sort = `floor ${order}, ${orderBy} ${order}`;
			}else if(orderBy === 'offering_price'){
				sort = `last_listed_sale_price_all ${order}, ${orderBy} ${order}`;
			}else if(orderBy === 'last_sold_date'){
				if(isContract){
					sort = `last_contract_date ${order}`;
				}else{
					sort = `${orderBy} ${order}, last_contract_date ${order}`;
				}
			}else{
				sort = `${orderBy} ${order}`;
			}
			
		}
		
		const unitsFq = [...fq, `building:${buildingKey}`];			
		let axiosData = {
			url: buildingUrl + "we3-properties?cache=60",
			method: "post",
			query: {
				q: q,
				fq: unitsFq,
				sort: sort,
				fl,
				wt: "json",
				rows: this.state.rowsPerPage,
				start: this.state.start,
						
			}
		};

		let response = await _axiosCall(axiosData)
			.then(res => {
				if(res && res.docs && res.docs.length>0){
					const newUnitListData = reset ? res.docs : [...this.state.unitListData, ...res.docs];
					this.setState( { unitListData: newUnitListData, fetchInProgress: false, buildingKey:false })
				}else if(res.docs.length === 0 ){
					this.setState( { noMoreResults: true, fetchInProgress: false, buildingKey:false })
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});
	}
	
	_selectUnit(property){
		const { selectedUnits } = this.state;
		const { handleSelectParent } = this.props;
		const newSelected = Object.assign({}, selectedUnits);
		
		if(newSelected[property.key]){
			delete newSelected[property.key];			
		}else{
			newSelected[property.key] = property;
		}
		handleSelectParent(property);
		
		this.setState( { selectedUnits: Object.assign({}, newSelected) } );
	}
	
	_handleSelectAllClick(){
		const { selectedUnits, unitListData } = this.state;
		const { handleSelectParentAll } = this.props;
		const { reactTableFiltered, groupedView, buildingKey } = this.props;
		let newSelected = {}
		if(groupedView || buildingKey){
			if(Object.keys(selectedUnits).length < unitListData.length){
				unitListData.forEach(item => {
					newSelected[item.key] = item;
				})
				handleSelectParentAll(unitListData, "add");
			}else{
				handleSelectParentAll(unitListData, "remove");
			}
		}else if(!groupedView){
			if(Object.keys(selectedUnits).length < reactTableFiltered.length){
				reactTableFiltered.forEach(item => {
					newSelected[item.key] = item;
				})
				handleSelectParentAll(reactTableFiltered, "add");
			}else{
				handleSelectParentAll(reactTableFiltered, "remove");
			}
		}
		
		
		this.setState( { selectedUnits: newSelected } );
		
	}
	
	render(){
		const { reactTableFiltered, handleBuildingClick, isSelected, handleClick, order, orderBy, selected, emptyRows, handleSelectAllClick, handleRequestSort, isGrouped, user, building, selectedUnitsAll} = this.props;
		
		const { selectedUnits } = this.state;
		if(!reactTableFiltered && (this.state.start===0 && (this.state.unitListData.length===0 || this.props.fetchInProgress))){
			return ( 			
				<LinearLoading />
			)
		}
		
		const data = reactTableFiltered || this.state.unitListData;
		
		
		if(building && (building.offering_verified_status != 'active' &&  parseInt(moment(building.cdec_date).format('YYYY')) <= 1970) && data.length <= 0 ){
			
			return (
			  <Col md={12}>
			    <Card>
			      <CardBody className={`small`}>
			        <div className={`email-confirmation`} >
			          <div className="email-confirmation__icon">
			            <AlertIcon size={50} color={`#D6BAE8`} />			            
			          </div>
			          <h3 className="email-confirmation__title">Agents Info Not Available</h3>
			          <p className="email-confirmation__sub">Marketproof is currently acquiring and verifying information for the building.
More details will be added to this building as they become available.</p>
			          
			        </div>
			      </CardBody>
			    </Card>
			  </Col>
			  )

		}else if( data.length <= 0 ){
			return (
			  <Col md={12}>
			    <Card>
			      <CardBody className={`small`}>
			        <div className={`email-confirmation`} >
			          <div className="email-confirmation__icon">
			            <AlertIcon size={50} color={`#D6BAE8`} />			            
			          </div>
			          <h3 className="email-confirmation__title">No Agents Found</h3>
			          <p className="email-confirmation__sub"></p>
			          
			        </div>
			      </CardBody>
			    </Card>
			  </Col>
			  )
		}
		
		
		return (
		<Fragment>
			<div>
			
			<Table className="material-table dashboard">
		        <UnitsSearchTableHead
		          numSelected={Object.keys(selectedUnits).length}
		          order={order}
		          orderBy={orderBy}
		          onRequestSort={isGrouped ? this._handleRequestUnitsSort : handleRequestSort}
		          rowCount={data.length}
		        />
		        <TableBody>
		          {data
		            .map((d) => {
		              const itemSelected = isSelected(d.id);
		              const floorplan = false; //_getUnitFloorPlan(d);
					  const buildingData = d;
					  //If building is sold out override stats
					  if(building && building.offering_verified_status === 'sold out'){						  
						  if(["active", "not_yet_recorded", "sold", "in contract", "resale"].indexOf(d.offering_status) < 0){
							  d.offering_status = "sold";
						  }						  
					  }
					  
					  if(d.baths % 1 == 0 && d.half_baths>0){
						  d.baths = d.baths + .5;
						  					  
					  }
					  let opPriceChange = false;
					  let soldPriceChange = false;
					  
					  if(building && building.building_status === 'sponsor'){	
					  	if((["active", "in contract", "pending"].indexOf(d.current_status)>=0) && typeof d["div(sub(offering_price, last_listed_sale_price_all), offering_price)"] === 'number' && d["offering_price"]>1000 ){
						 	opPriceChange = Math.round(d["div(sub(offering_price, last_listed_sale_price_all), offering_price)"] * 10000 * -1)/100;
					  	}
					  	if(d.last_sold_price > 1000 && typeof d["div(sub(offering_price, last_sold_price), offering_price)"] === 'number' && d["offering_price"]>1000 ){
						   	soldPriceChange = Math.round(d["div(sub(offering_price, last_sold_price), offering_price)"] * 10000 * -1)/100;
						}
					  }
		              return (
		                <TableRow
		                  className="material-table__row"
		                  role="checkbox"
		                  onClick={event => {
							event.stopPropagation(); // optional
							window.open(`mailto:${d.email}`, '_blank');
						  }}

		                  aria-checked={itemSelected}
		                  tabIndex={-1}
		                  key={d.id}
		                  selected={itemSelected}
		                >
		                 
		                  {/* <TableCell className="material-table__cell" padding="checkbox">
								 <Checkbox checked={selectedUnitsAll[d.key]===undefined ? false : true} onClick={(e)=>{e.preventDefault();e.stopPropagation(); this._selectUnit(d);}} className={`material-table__checkbox ${selectedUnitsAll[d.key]!==undefined && 'material-table__checkbox--checked'}`} />							
						  </TableCell> */}
		                 {!isMobile && <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small"       
							                  
		                  >
						  	<div style={{position:"relative", display:"flex",alignItems:"center", gap:"15px"}} >
		                  	 <div className="dashboard__table-orders-img-wrap" style={{position:"relative",left:0}}>
								 {d.image
								   ? <div className="dashboard__table-orders-img" style={{ backgroundImage: `url(${d.image ? d.image : "/img/ava.png"})` }} />
								   : <div className="dashboard__table-orders-img" style={{ background: profileColors[Math.floor(Math.random() * profileColors.length)], textAlign: 'center', lineHeight: '32px', fontSize:'15px', color: '#FFF' }}>{d.display_name[0]}</div>
							   }
							 </div>
							 <div>{_capitalizeText(d.display_name)}</div>
							  </div>
							  
		                  </TableCell> }
						  
						  <TableCell
		                    className="material-table__cell material-table__cell-right nowrap"
		                    component="td"
		                    scope="row"
		                    padding=""
		                  >
		                  	 {d.company_name ? _capitalizeText(d.company_name.toLowerCase().replace('llc', '').replace(',', '').replace('.', '')) : "--"}
		                   	
		                   	
		                   	
		                   	
		                  </TableCell>
						 
		                 <TableCell
							 className="material-table__cell material-table__cell-right"
							 size="small"                          
						   >
							   
							   <a className="link-text" href={`mailto:${d.email}`}>{d.email}</a>
							   
						   </TableCell>
		                  <TableCell
		                    className="material-table__cell material-table__cell-right"
		                    size="small"                          
		                  >
		                  <div
							onClick={event => {
							  event.stopPropagation();
							  window.open(`tel:${d.phone_mobile || d.phone}`, '_blank');
							}}
							className="link-text"
						  >
							{d.phone_mobile ? d.phone_mobile : d.phone}
							<span className="light-text small-text"> (mobile)</span>
						  </div>
						  
						  {d.office_phone && (
							<div
							  onClick={event => {
								event.stopPropagation();
								window.open(`tel:${d.office_phone}`, '_blank');
							  }}
							  className="link-text"
							>
							  {d.office_phone}
							  <span className="light-text small-text"> (office)</span>
							</div>
						  )}
		                  </TableCell>
		                  <TableCell
								className="material-table__cell material-table__cell-right nowrap"
								component="td"
								scope="row"
								padding=""
							  >
							  {d.solr_updated_date ? moment(d.solr_updated_date).format("M/D/YYYY")  : null}
						  <span className="light-text small-text"><br/>{d.solr_updated_date ? "("+moment(d.solr_updated_date).fromNow()+")"  : null}</span>
							</TableCell>
						  
		                           
		                
		                </TableRow>
		              );
		            })}
		          {emptyRows > 0 && (
		            <TableRow style={{ height: 49 * emptyRows }}>
		              <TableCell colSpan={6} />
		            </TableRow>
		          )}
		        </TableBody> 
		        
              
		      </Table>
		      </div>
		     
			   {!reactTableFiltered && 
				<div className="unit__load">			   		
				    <Tooltip title="Load more units">
				        <Button
					        onClick={(e) => {this._loadMore(e)}}
					         variant="contained"
					         color="news"
					         className={`timeline__load-more`}		         
					         startIcon={<LoadMoreIcon />}
					         disabled={this.state.fetchInProgress || this.state.noMoreResults}
					     >	{`${this.state.fetchInProgress ? "Loading..." : this.state.noMoreResults ? "No More Units" : "Load More"}`}
					     </Button>				 
				  	</Tooltip>				
			    </div>
			    }
			</Fragment>
		);
	}
}

export default connect(state => ({
  user: state.user
}))(UnitsListTable);